import createAccountRpcService from 'services/rpc/accountRpcService';
import useAxios from '../utils/useAxios';

export default function useAccountRpc() {
  return createAccountRpcService(useAxios());
}
